import { render, staticRenderFns } from "./link-types-card.vue?vue&type=template&id=58d7058e&scoped=true&"
import script from "./link-types-card.vue?vue&type=script&lang=js&"
export * from "./link-types-card.vue?vue&type=script&lang=js&"
import style0 from "./link-types-card.vue?vue&type=style&index=0&id=58d7058e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d7058e",
  null
  
)

export default component.exports